<template>
    <div class="wrap">
        <el-page-header @back="core.goBack" ></el-page-header>
        <div class="content_one">
            <div class="content_one_title">
                {{projectList[pattern].title}}
            </div>
            <div class="content_one_text">
                <div class="principle_wrap text_wrap">
                    <div class="one_title">实验原理：</div>
                    <div class="one_text">
                        {{projectList[pattern].principle}}
                    </div>
                </div>
                <div class="step_wrap text_wrap">
                    <div class="one_title">实验步骤：</div>
                    <div class="one_text">
                        {{projectList[pattern].step}}
                    </div>
                </div>
                <div class="prepare_wrap text_wrap">
                    <div class="one_title">实验准备：</div>
                    <div class="one_text">
                        {{projectList[pattern].prepare}}
                    </div>
                </div>
            </div>
            <div class="notice_text">温馨提示：市场有风险，投资需谨慎！</div>
            <div class="pattern_wrap">
                <div class="img_wrap" @click="toPrac">
                    <div><img src="../../assets/img/buttonOne.png" alt=""></div>
                    <div>练习模式</div>
                </div>
                <div class="img_wrap" @click="toNext(4)">
                    <div><img src="../../assets/img/buttonTwo.png" alt=""></div>
                    <div>考核模式</div>
                </div>
                <div class="img_wrap" @click="toNext(5)">
                    <div><img src="../../assets/img/buttonThree.png" alt=""></div>
                    <div>实验记录</div>
                </div>
            </div>
        </div>
        <!-- <div class="back_index" @click="toIndex"><i class="iconfont icon-home"></i></div> -->
    </div>
</template>
<script>
import config from '@/config'
export default {
    data() {
        return {
            pattern: Number(this.$route.query.pattern),
            projectList:[{
                title:'单个期权套期保值实验',
                url:`${this.$config.baseUrl}/kd/#/Dashboard`,
                principle:'本实验根据《金融交易策略设计与模拟》等理论课程的大纲要求，将期权基础知识考核、期权实战规则、模拟开户和期权策略设计等内容融会贯通于十个步骤，考察学生利用期权策略进行套期保值，建立对冲机制，以使价格风险降到最低限度的能力。',
                step:'1. 实验背景介绍；2. 期权实战规则；3. 模拟开户；4. 银期转账；5. 实验角色选择；6. 行情查看与期权选择；7. 期权开仓；8. 期权平仓；9. 核算损益；10. 填写实验报告。',
                prepare:'完成此实验前，应该了解期权的相关定义、期权的交易规则、期权交易的核算规则等相关知识点。'
            },{
                title:'双限期权套期保险实验',
                url:`${this.$config.baseUrl}/kdChallenge/#/Dashboard`,
                principle:'本实验根据《金融交易策略设计与模拟》等理论课程的大纲要求，将期权delta风险中性策略、交叉对冲和期权组合策略设计等知识点融会贯通于十个步骤，考察学生利用多个期权策略进行套期保值，建立对冲机制，以使价格风险降到最低限度的能力。',
                step:'1. 关于交叉对冲的实验背景；2. 关于delta动态调仓的实验背景；3.实验案例；4.最优对冲比率计算；5.合约选择；6.期权组合开仓；7.期权组合调仓；8.期权组合平仓；9.核算损益；10.填写实验报告。',
                prepare:'开始实验前，应了解期权定义、期权交易规则、希腊字母delta、交叉对冲和不同期权组合策略的盈亏图。'
            },{
                title:'期货套期保值实验',
                url:`${this.$config.baseUrl}/future/#/Dashboard`,
                principle:'本实验根据《金融交易策略设计与模拟》等理论课程的大纲要求，将期货基础知识考核、期货实战规则、模拟开户和期货策略设计等内容融会贯通于十个步骤，考察学生利用期货策略进行套期保值，建立对冲机制，以使价格风险降到最低限度的能力。',
                step:'1. 期货交易实例；2. 期货实战规则；3. 期货账户开户；4. 银期转账；5. 实验案例和实验角色选择；6. 期货合约选择；7. 期货合约开仓；8. 期货合约平仓；9.核算损益；10. 填写实验报告',
                prepare:'完成此实验前，应该了解期货的相关定义、期货的交易规则、期货交易的核算规则、期货套期保值的原理等相关知识点。'
            },{
                title:'期货套利实验',
                url: `${this.$config.baseUrl}/future/#/Dashboard`,
                principle:'本实验根据《金融交易策略设计与模拟》等理论课程的大纲要求，将套利模式选择和期货套利策略设计及运行等内容融会贯通于六个步骤，考察学生寻找套利机会并设计多种套利策略的能力。',
                step:'1.套利模式选择；2.数据窗口选择；3.无套利区间构造；4.套利策略实施；5.套利策略结果；6.填写实验报告。',
                prepare:'完成此实验前，应该了解期货的相关定义、期货交易规则、期货交易核算规则、期货套利策略的原理等相关知识点。'
            },{
                title:'期权套利实验',
                url: `${this.$config.baseUrl}/future/#/Dashboard`,
                principle:'本实验根据《金融交易策略设计与模拟》等理论课程的大纲要求，将套利机会发现、期权交易策略设计及运行等内容融会贯通于五个步骤，考察学生寻找并设计多种套利策略的能力。期权无风险套利主要包括单个期权套利、期权垂直价差套利、蝶式套利、飞鹰式套利、买卖权平价套利和盒式套利等',
                step:'1.寻找套利机会；2.策略设计；3.策略结果；4.策略结果库；5.填写实验报告。',
                prepare:'完成此实验前，应该了解期权的相关定义、期权交易策略的原理、期权交易规则、期权交易核算规则等相关知识点。'
            }],
        };
    },
    mounted(){
        
    },
    methods: {
        toIndex() {
            this.$router.go(-1)
        },
        toPrac(){
            this.core.toSubSystem('','','',this.pattern)
        },
        //index代表页面下标，判断去考核模式还是实验记录
        toNext(index) {
            sessionStorage.setItem('pattern',this.pattern)
            this.$router.push(`dashboard#${index}`)
            sessionStorage.setItem('isOld',true)
        },
    },
};
</script>
<style lang="scss" scoped>
.back_index:hover{
    opacity: 0.8;
    cursor: pointer;
}
.back_index{
    position: fixed;
    right: 0px;
    top: 48%;
    width: 80px;
    height: 80px;
    background: white;
    text-align: center;
    .icon-home{
        font-size: 50px;
        color: #FF5288;
        font-weight: 600;
        line-height: 80px;
    }
}
.wrap{
    width: 100%;
    height: 100%;
    font-family: '微软雅黑';
}
.content_one{
    width: 100%;
    background: white;
    .content_one_title{
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 50px;
        letter-spacing:8px;
        font-weight: 550;
        color: #FF5288;
    }
    .content_one_text{
        padding: 0px 60px;
        width: 95%;
        margin: auto;
        background-size: 100% 100%;
        border-radius: 20px;
        height: 400px;
        overflow: hidden;
        background-size: 100% 100%;
        background: url('../../assets/img/content.jpg') no-repeat;
    }
}
.text_wrap{
    display: flex;
    .one_title{
        width: 280px;
        height: 130px;
        line-height: 130px;
        font-size: 28px;
        color: #FF5288;
        letter-spacing:4px;
        box-sizing: border-box;
        font-weight: 550;
        }
    .one_text{
        width: 2300px;
        height: 130px;
        padding: 45px 0px;
        box-sizing: border-box;
        font-size: 23px;
        line-height: 2;
        color: #4D4D4F;
        letter-spacing:2px;
        font-weight: 60;
        }
}
.notice_text{
    font-size: 22px;
    color: #FF5288;
    padding: 20px 0px 0px 100px;
}
.pattern_wrap{
    width: 100%;
    padding: 0px 100px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    .img_wrap{
        margin-top: 30px;
        width: 450px;
        height: 320px;
        text-align: center;
        box-shadow: -2px 6px 10px -4px rgba(136,80,98,0.75);
        -webkit-box-shadow: -2px 6px 10px -4px rgba(136,80,98,0.75);
        -moz-box-shadow: -2px 6px 10px -4px rgba(136,80,98,0.75);
        font-size: 23px;
        color: #FF5288;
        font-weight: 550;
        letter-spacing:3px;
    }
    .img_wrap:hover{
        box-shadow: -2px 6px 10px -6px rgba(136,80,98,0.75);
        -webkit-box-shadow: -2px 6px 10px -6px rgba(136,80,98,0.75);
        -moz-box-shadow: -2px 6px 10px -6px rgba(136,80,98,0.75);
        cursor: pointer;
        img{
            opacity: 0.9;
        }
    }
    img{
        width: 80%;
        height: 70%;
    }
}
</style>